import React, { useEffect } from 'react';
import SaasCtaButton from './SaasCtaButton';
import SaasHeroVisual from './SaasHeroVisual';
import SaasHeroVisualMobile from './SaasHeroVisualMobile';

const SaasHeroSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="relative bg-white overflow-x-hidden overflow-y-visible text-gray-800 mb-0 min-h-[60vh] md:min-h-[80vh]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 h-full flex items-center pt-12 md:pt-20 pb-8 md:pb-16">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 items-center">
          <div className="text-center lg:text-left space-y-3 md:space-y-6 lg:pr-4 order-1">
            <div className="space-y-2 md:space-y-4">
              <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-black/80 mb-1 md:mb-2 text-center lg:text-left">
                For SaaS Companies
              </p>
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[3.25rem] xl:text-6xl font-bold tracking-tight text-black leading-[1.08]">
                Your Entire AI Growth Engine
                <br />
                <span className="bg-gradient-to-r from-[#8ae690] to-[#7ad67f] bg-clip-text text-transparent">
                  in one place.
                </span>
              </h1>

              <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 pt-1">
                Capture leads, turn them into customers, follow up, book meetings, and keep people paying, without juggling
                five different tools.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                Kolanut connects your stack and shows you what to do next. You approve it. Run it from web or phone.
              </p>
            </div>

            <div className="space-y-3 md:space-y-5 flex flex-col items-center lg:items-start pt-1">
              <div className="flex items-center justify-center lg:justify-start w-full sm:w-auto">
                <SaasCtaButton className="hidden sm:inline-flex w-full sm:w-auto" />
              </div>
              <p className="text-xs sm:text-sm text-black/70 text-center lg:text-left leading-snug px-1 sm:px-0">
                Real-time oversight from your phone · Company Brain · AI agents · No black-box automation
              </p>
            </div>
          </div>

          <div className="relative order-2 flex flex-col items-center w-full max-w-[100vw] overflow-hidden sm:overflow-visible sm:mx-auto sm:max-w-lg lg:max-w-none lg:mx-0">
            <div className="block w-full sm:hidden">
              <SaasHeroVisualMobile />
            </div>
            <div className="hidden w-full sm:block">
              <SaasHeroVisual />
            </div>
            <p className="mt-4 text-center text-[10px] text-gray-400 max-w-xs sm:max-w-none px-4 sm:px-0">
              Swipe tabs: Growth copilot, Ads, Onboarding, Support, Retention.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SaasHeroSection;
